module.exports = __webpack_public_path__ + "media/pro/ProWeekly_Landing-d7cbbe50.svg";